module.exports = __webpack_public_path__ + "static/media/likeTwitter.33acfaa9.svg";